import { useReadSource } from "../../data/readSource";
import "./asClient.css";

/**
 * What stands where the client sees something personal to one person: notiser, inloggningar, the
 * device, the notification choices, the profile and Hemligheter (Portal HQ, 2026-10-11).
 */
export function PersonalLeftOut() {
  const source = useReadSource();
  return (
    <div className="panel as-client-left-out" data-testid="as-client-left-out">
      <p>Kundens egna val visas inte här.</p>
      {source.kind === "admin" ? (
        <p className="as-client-left-out-why">
          Det här hör till en person och inte till {source.tenantName}, så vyn läser det inte.
        </p>
      ) : null}
    </div>
  );
}
